<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-title>
        {{ $t('vmail.cfg.greeting.archive.title') }}
      </v-card-title>
      <v-card-text class="archive-list">
        {{ $t('vmail.cfg.greeting.archive.subtitle', { name: name }) }}
        <v-radio-group v-model="restoreId">
          <v-list dense>
            <v-list-item-group>
              <v-list-item class="archive-item"
                v-for="(archive, i) in archives" :key="i">

                <v-list-item-action>
                  <v-radio :value="archive.id"></v-radio>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ archive.archive_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ archive.updated_at | formatDateLong($i18n.locale) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="archive-action">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon @click="playArchive(archive.id)">
                        <v-icon>
                          {{ playId === archive.id ? 'mdi-stop' : 'mdi-play' }}
                        </v-icon>
                      </v-btn>
                     </template>
                     <span>{{ $t(playerTooltip(archive.id)) }}</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')" text>
          {{ $t('vmail.cfg.greeting.btnCancel') }}
        </v-btn>
        <v-btn :disabled="!readyRestore" @click="restore" :loading="submitting" color="primary" text>
          {{ $t('vmail.cfg.greeting.archive.btnRestore') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <audio ref="player"/>
  </v-dialog>
</template>

<script>
import API from '@/api'
import events from 'Store/events'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'vmail-greeting-restore-form',
  data () {
    return {
      submitting: false,
      loading: false,
      playId: 0,
      restoreId: 0
    }
  },
  props: {
    show: {
      type: Boolean
    },
    name: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      archives: 'voicemails/archives'
    }),
    readyRestore: function () {
      return this.restoreId > 0
    }
  },
  methods: {
    ...mapActions({ loadArchives: 'voicemails/loadArchives' }),
    playArchive: function (aid) {
      this.$refs.player.pause()

      if (this.playId === aid) { // stop playing
        this.playId = 0
        return
      }

      this.loading = true
      this.playId = aid
      API.VMAudioSrc(aid).then(response => {
        this.$refs.player.onended = () => {
          this.playId = 0
        }
        this.$refs.player.src = URL.createObjectURL(response.data)
        this.$refs.player.play().catch(e => this.dbg('RestoreForm: play failed: %o', e))
      }).catch(err => {
        this.playId = 0
        this.dbg(err)
        events.pubError(`Failed to load audio to play archive id ${aid}`)
      }).finally(() => {
        this.loading = false
      })
    },
    playerTooltip: function (aid) {
      return this.playId === aid
        ? 'vmail.cfg.greeting.archive.ttStop'
        : 'vmail.cfg.greeting.archive.ttPlay'
    },
    getFolderName: function () {
      switch (this.name) {
        case 'greeting':
          return 'greet'
        case 'unavailable':
          return 'unavail'
        default:
          return this.name
      }
    },
    restore: function () {
      this.submitting = true
      this.playId = 0
      this.$refs.player.pause()

      this.loading = true
      API.restoreVMArchive(this.restoreId, this.getFolderName()).then(() => {
        return this.loadArchives()
      }).then(() => {
        this.submitting = false
        this.$emit('restored')
        this.$emit('close')
        events.pubNotify({ text: 'vmail.cfg.greeting.archive.success', status: 'success' })
      }).catch(err => {
        this.dbg(err)
        events.pubError('Failed to restore archive.')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.archive-list {
  max-height: 400px;
  overflow-y: auto;
}
.archive-action {
  display: block;
}
.archive-item {
  padding-right: 3px;
}
</style>
